import { render } from "./CriminalModal.vue?vue&type=template&id=2fe61565&scoped=true"
import script from "./CriminalModal.vue?vue&type=script&lang=js"
export * from "./CriminalModal.vue?vue&type=script&lang=js"

import "./CriminalModal.vue?vue&type=style&index=0&id=2fe61565&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe61565"]])

export default __exports__